import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=65b4ac11&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4ac11",
  null
  
)

export default component.exports